<template>
  <div class="centered">
    <a-col :xs="20" :md="12">
      <a-typography-title
        style="bottom: 0px; font-family: 'Urbanist'; text-align: center"
      >
        Este enlace expiró, pero no te preocupes!
      </a-typography-title>
    </a-col>

    <img
      src="@/assets/images/token-expired.svg"
      class="img-margin-ready centered-image"
    />

    <a-col :xs="20" :md="12">
      <a-typography-title
        style="
          bottom: 0px;
          font-family: 'Urbanist';
          text-align: center;
          color: #273cf5;
        "
      >
        Presiona el siguiente botón para reenviar:
      </a-typography-title>
    </a-col>
    <DownOutlined class="arrow-icon bounce" />

    <a-button
      type="primary"
      size="large"
      class="main-action"
      @click="resendToken"
      :loading="loading"
      :disabled="disabled"
    >
      Enviar nuevo enlace
    </a-button>

    <br />

    <a-col :xs="20" :md="12">
      <p class="instruction">
        El enlace llegará al mismo correo donde recibiste el anterior.
      </p>
    </a-col>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { useStore } from 'vuex';
import { FETCH_DIGITAL_FORM_RESETTED_TOKEN } from '@/store/types';
import notification from '@/utils/notifications';
import { useRoute } from 'vue-router';
import { DownOutlined } from '@ant-design/icons-vue';

const loading = ref(false);
const store = useStore();
const disabled = ref(false);
const route = useRoute();
const token = route.params.token;

const resendToken = () => {
  loading.value = true;
  store
    .dispatch(FETCH_DIGITAL_FORM_RESETTED_TOKEN, token)
    .then(() => {
      notification(
        'success',
        'Correcto',
        'Se a enviado un correo con un nuevo enlace'
      );
      disabled.value = true;
    })
    .catch((error) => {
      notification('error', 'Error', error.response.data.message);
    })
    .finally(() => {
      loading.value = false;
    });
};
</script>

<style scoped>
.centered {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 80px;
}
.centered-image {
  height: 280px;
}
:deep(.ant-typography) {
  margin-bottom: -10px;
}

@keyframes bounce {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(8px);
  }
}

.bounce {
  animation: bounce 1.1s infinite;
}
.arrow-icon {
  font-size: 25px;
  color: #273cf5;
  margin: 15px 0 15px;
}

.instruction {
  font-size: 18px;
  font-weight: 600;
  text-align: center;
  margin-top: 12px;
}

.main-action {
  height: 64px;
  font-size: 20px;
  padding: 0 10px;
  font-weight: 600;
}
</style>
